import type { KnotCategory, KnotMode } from '@shared/knot-schema';

export interface StarterKnot {
  name: string;
  slug: string;
  mode: KnotMode;
  category: KnotCategory;
}

export const STARTER_KNOTS: StarterKnot[] = [
  { name: 'Palomar', slug: 'palomar', mode: 'stopmotion', category: 'terminal' },
  { name: 'Improved Clinch', slug: 'improved-clinch', mode: 'stopmotion', category: 'terminal' },
  { name: 'Uni', slug: 'uni', mode: 'stopmotion', category: 'terminal' },
  { name: "Surgeon's Knot", slug: 'surgeons', mode: 'stopmotion', category: 'bend' },
  { name: 'Dropper Loop', slug: 'dropper-loop', mode: 'stopmotion', category: 'loop' },
  { name: 'FG Knot', slug: 'fg-knot', mode: 'stopmotion', category: 'bend' },
  { name: 'Bimini Twist', slug: 'bimini-twist', mode: 'stopmotion', category: 'loop' },
  { name: 'Albright', slug: 'albright', mode: 'stopmotion', category: 'bend' },
];
